import './App.css';
import Landing from './pages/Landing/Landing';
import Dashboard from './pages/Dashboard/Dashboard';
import DashboardSchool from './pages/DashboardSchool/DashboardSchool';
import SchoolDetail from './pages/SchoolDetail/SchoolDetail';
import ProviderModal from './pages/ProviderModal/ProviderModal';
import Boclips from './pages/Boclips/Boclips';
import Scholarlab from './pages/Scholarlab/Scholarlab';
import Calendar from './pages/Calendar/Calendar';
import Profile from './pages/Profile/Profile';
import OTPVerification from './pages/OTPVerification/OTPVerification';
import PasswordVerification from './pages/PasswordVerification/PasswordVerification';
import QrLogin from './pages/QrLogin/QrLogin';
import About from './pages/About/About';
import Contact from './pages/Contact/Contact';
import Activities from './pages/Activities/Activities';
import SchoolActivities from './pages/SchoolActivities/SchoolActivities';
import Integrations from './pages/Integrations/Integrations';
import IDPIntegration from './pages/Integrations/IDPIntegration';
import FAQ from './pages/FAQ/FAQ';
import PrivacyPolicy from './pages/PrivacyPolicy/PrivacyPolicy';
import TermsOfCondition from './pages/TermsOfCondition/TermsOfCondition';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';
import { SystemSettingsProvider } from './contexts/SystemSettingsContext';
import { useSystemSettings } from './contexts/SystemSettingsContext';
import Global404Page from './components/Global404Page/Global404Page';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

function AppRoutes() {
  const { global404Enabled, global404Loading } = useSystemSettings();

  if (global404Loading) return null;
  if (global404Enabled) return <Global404Page />;

  return (
    <Routes>
            <Route path='/' element={<Landing />} />
            <Route path='/about' element={<About />} />
            <Route path='/contact' element={<Contact />} />
            <Route path='/integrations' element={<Integrations />} />
            <Route path='/integrations/idp' element={<IDPIntegration />} />
            <Route path='/otp-verification' element={<OTPVerification />} />
            <Route path='/otp-verification' element={<OTPVerification />} />
            <Route path='/password-verification' element={<PasswordVerification />} />
            <Route path='/q' element={<QrLogin />} />
            <Route path='/faq' element={<FAQ />} />
            <Route path='/privacy-policy' element={<PrivacyPolicy />} />
            <Route path='/terms-of-condition' element={<TermsOfCondition />} />

            {/* Protected Routes - Require Authentication */}
            {/* <Route path='/dashboard' element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } /> */}
            <Route path='/dashboard' element={<Dashboard />} />
            <Route path='/dashboard/activities' element={<Activities />} />
            <Route path='/mydashboard' element={<DashboardSchool />} />
            <Route path='/mydashboard/activities' element={<SchoolActivities />} />
            <Route path='/school/:schoolId' element={<SchoolDetail />} />
            <Route path='/home' element={
              <ProtectedRoute>
                <ProviderModal />
              </ProtectedRoute>
            } />
            <Route path='/providers/boclips' element={
              <ProtectedRoute>
                <Boclips />
              </ProtectedRoute>
            } />
            <Route path='/providers/scholarlab' element={
              <ProtectedRoute>
                <Scholarlab />
              </ProtectedRoute>
            } />
            <Route path='/calendar' element={
              <ProtectedRoute>
                <Calendar />
              </ProtectedRoute>
            } />
            <Route path='/profile' element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            } />
    </Routes>
  );
}

function App() {
  return (
    <div>
      <BrowserRouter>
        <SystemSettingsProvider>
          <AppRoutes />
        </SystemSettingsProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
